import { IAppState } from 'src/interface/IAppState';

export function answerListStateSelector(appState: IAppState) {
  return appState.answerState;
}